<script setup>
import {ref} from "vue";
import {axiosCatchHandler} from "../../modules/sharedGlobal";
import axios from "axios";
import Swal from 'sweetalert2';

const props = defineProps({
  isChallenge: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  isolated: {
    type: Boolean,
    required: false,
    default: () => false,
  },
});

const emits = defineEmits(['confirmed', 'failed'])

const code = ref(null);
const errors = ref({});
const loading = ref(false);

const handleSubmit = async () => {
  loading.value = true;

  try {
    const url = props.isChallenge ? '/two-factor/challenge' : '/two-factor/login';

    const { data } = await axios.post(url, {
      code: code.value,
    });

    loading.value = false;

    if(props.isChallenge) {
      emits('confirmed');

      return;
    }

    window.location.href = data.redirectUrl;
  } catch (error) {
    loading.value = false;

    if (error.response.status === 422) {
      errors.value = error.response.data.errors;
    } else {
      Swal.fire({
        title: "Whoops",
        html: 'Something went wrong, please try again later.',
        icon: 'warning',
      });
    }

    emits('failed');

    axiosCatchHandler(error, () => {});
  }
}
</script>

<template>
  <div class="container">
    <div class="row flex-column">
      <div :class="isolated ? '' : 'col-12 col-sm-10 col-lg-6 ml-auto mr-auto'">
        <div :class="{card: !isolated}">
          <div class="card-body">
            <h3
              v-if="!isolated"
              class="text-center xs-mt-10 xs-mb-0"
            >
              <strong>Two-factor Authentication</strong>
            </h3>

            <slot>
              <p class="text-center">
                Enter your Authentication code below to continue to your dashboard.
              </p>
            </slot>

            <div class="d-flex justify-content-center align-items-center flex-column my-4">
              <input
                v-model="code"
                type="text"
                required
                class="form-control w-75"
                :class="{
                  'error': errors.code || errors.recovery_code
                }"
                placeholder="Enter Authentication Code"
                autocomplete="off"
                @keyup.enter="handleSubmit"
              >
              <div
                v-if="errors.code"
                class="text-danger w-75"
              >
                <small
                  v-for="(error, index) in errors.code"
                  :key="index"
                >
                  {{ error }}<br>
                </small>
              </div>
              <div
                v-if="errors.recovery_code && !errors.code"
                class="text-danger w-75"
              >
                <small
                  v-for="(error, index) in errors.recovery_code"
                  :key="index"
                >
                  {{ error }}<br>
                </small>
              </div>
            </div>

            <div class="text-center">
              <button
                :disabled="loading"
                class="btn btn-lg button font-weight-bold btn-info m-0 mb-2"
                @click="handleSubmit"
              >
                Submit
              </button>
            </div>

            <p class="text-center xs-mt-5 text-info">
              If you are unable to use your authentication code,<br> enter one of your recovery codes in the field
              above.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.text-info {
  color: #00c6dd;
}
</style>
